var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/verification_badge.tsx";
import classNames from 'classnames';
import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import Icon from 'soapbox/components/ui/icon/icon';
import { useSoapboxConfig } from 'soapbox/hooks';
const messages = defineMessages({
  verified: {
    "id": "account.verified",
    "defaultMessage": "Verified Account"
  }
});
const VerificationBadge = ({
  className
}) => {
  const intl = useIntl();
  const soapboxConfig = useSoapboxConfig();

  // Prefer a custom icon if found
  const icon = soapboxConfig.verifiedIcon || require('icons/verified.svg');

  // Render component based on file extension
  const Element = icon.endsWith('.svg') ? Icon : 'img';
  return /*#__PURE__*/React.createElement("span", {
    className: "verified-icon",
    "data-testid": "verified-badge",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 27,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Element, {
    className: classNames('w-4 text-accent-500', className),
    src: icon,
    alt: intl.formatMessage(messages.verified),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 28,
      columnNumber: 7
    }
  }));
};
export default VerificationBadge;